import React, {useState} from 'react'
import { useNavigate } from 'react-router-dom'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CreateIcon from "@mui/icons-material/Create";
// import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
// import EmailIcon from "@mui/icons-material/Email";
// import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import avtar from "../../../MobileScreens/assets/images/Profile-Picture.jpg";
// import Switch from '@mui/material/Switch';
import CloseIcon from '@mui/icons-material/Close';
// import AttachmentIcon from '@mui/icons-material/Attachment';
import { red } from '@mui/material/colors';
import document from "../../../MobileScreens/assets/images/updated-aadhaar.png";
import Zoom from "react-medium-image-zoom";
import BackupIcon from '@mui/icons-material/Backup';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../FormikControl";

function MobileAddServiceProvider() {
  const navigate = useNavigate();
  // const label = { inputProps: { 'aria-label': 'Switch demo' } };
  const [passHideShow, setPassHideShow] = useState(false);
  const [serviceType, setServiceType] = React.useState('');
  const handleChange = (event) => {
    setServiceType(event.target.value);
  };

  const initialValues = {
    first_name: "",
    last_name: "",
    phone_no: "",
    age: "",
    qualification: "",
    address: "",
  };

  const validationSchema = Yup.object({
    first_name: Yup.string().required("Required"),
    last_name: Yup.string().required("Required"),
    phone_no: Yup.string().required("Required"),
    age: Yup.string().required("Required"),
    qualification: Yup.string().required("Required"),
    address: Yup.string().required("Required"),
  });

  const onSubmit = (values) => console.log("Form Data", values);

  const initialValuesVehicleInfo = {
    owner_name: "",
    registration_no: "",
    vehicle_no: "",
  };

  const validationSchemaVehicleInfo = Yup.object({
    owner_name: Yup.string().required("Required"),
    registration_no: Yup.string().required("Required"),
    vehicle_no: Yup.string().required("Required"),
  });

  const onSubmitVehicleInfo = (values) => console.log("Form Data", values);
  return (
    <>
    <div>
      <div className="drawerFixedPatch"></div>
      <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
          className="backArrowMobil"
          onClick={() => navigate("/MobileServiceProvider")}
        />
        <h1>Add Service Provider</h1>
      </div>
    </div>
    <div className="wraperMobile">
      <div className="sectionMobile">
        <div className="famDetailsListMainMob CenterViewBtn">
          <div className="CenterImageView">
          <div className="EditProfileImageView">
              <img src={avtar} className="EditProfileImage" />
            <div className="EditIconImageView">
              <CreateIcon sx={{fontSize:20, color:'#0044ff'}}/>
              <input type='file' className='ImageEditBtn'/>
            </div>
          </div>
          </div>
          <div className="famDetailsListInrMob">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {(formik) => (
          <Form>
            <div className='FormView'>
              <div className='lebalInputView'>
              <FormikControl
                control="input"
                type="text"
                label="First Name"
                placeholder="Enter First Name"
                labelclassName="inputLebal"
                name="first_name"
                className="titleInput"
              />
              </div>
              <div className='lebalInputView'>
              <FormikControl
                control="input"
                type="text"
                label="Last Name"
                placeholder="Enter Last Name"
                labelclassName="inputLebal"
                name="last_name"
                className="titleInput"
              />
              </div>
              <div className='lebalInputView'>
              <FormikControl
                control="input"
                type="text"
                label="Phone Name"
                placeholder="Enter phone no"
                labelclassName="inputLebal"
                name="phone_no"
                className="titleInput"
              />
              </div>
              <div className='lebalInputView'>
              <p className='inputLebal'>Service Type</p>
              <Select
                value={serviceType}
                onChange={handleChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                >
                <MenuItem value="">
                    <em>None</em>
                </MenuItem>
                <MenuItem value={'maid'}>Maid</MenuItem>
                <MenuItem value={'milk'}>Milk</MenuItem>
                <MenuItem value={'cook'}>Cook</MenuItem>
                <MenuItem value={'carwash'}>Car Washer</MenuItem>
                <MenuItem value={'other'}>Add Other</MenuItem>
              </Select>
              </div>
              <div className='lebalInputView'>
              <FormikControl
              		control="input"
              		type="text"
              		label="Age"
              		placeholder="Enter age"
              		labelclassName="inputLebal"
              		name="age"
              		className="titleInput"
            		/>
              </div>
              
              <div className='lebalInputView'>
              <FormikControl
                control="input"
                type="text"
                label="Qualification"
                placeholder="Enter qualification"
                labelclassName="inputLebal"
                name="qualification"
                className="titleInput"
              />
              </div>
              <div className='lebalInputView'>
                <FormikControl
              		control="input"
              		type="text"
              		label="Address"
              		placeholder="Enter address"
              		labelclassName="inputLebal"
              		name="address"
              		className="titleInput"
            		/>
              </div>
            </div>
            <button className='submitButton GreenBack' type='submit'>Submit</button>
            </Form>
            )}
            </Formik>
          </div>
          
          <div className="ProfileChangePassBtnView" onClick={()=>setPassHideShow(!passHideShow)}> 
            <p className="ChangePassTxt">Add Vehicle Details</p>
          </div>
          
          {passHideShow?<div className="famDetailsListInrMob">
            <Formik
            initialValues={initialValuesVehicleInfo}
            validationSchema={validationSchemaVehicleInfo}
            onSubmit={onSubmitVehicleInfo}
            >
            {(formik) => (
            <Form>
            <div className='FormView'>
            <div className='lebalInputView'>
              <FormikControl
                control="input"
                type="text"
                label="Owner Name"
                placeholder="Enter owner name"
                labelclassName="inputLebal"
                name="owner_name"
                className="titleInput"
              />
              </div>
              <div className='lebalInputView'>
              <FormikControl
                control="input"
                type="text"
                label="Registration Number"
                placeholder="Enter registration no"
                labelclassName="inputLebal"
                name="registration_no"
                className="titleInput"
              />
              </div>
              <div className='lebalInputView'>
              <FormikControl
                control="input"
                type="text"
                label="Vehicle Number"
                placeholder="Enter vehicle number"
                labelclassName="inputLebal"
                name="vehicle_no"
                className="titleInput"
              />
              </div>
              <div className='attchmentView'>
              <BackupIcon sx={{ fontSize: 30, color: '#3853ec' }} />
              <input type='file' className='fileUploadButton'/>
              <p className='checkBoxTxt'>Document's</p>
              </div>
              <div className="mobDocumentInr">
                <div className="mobDocumentPrev">
                  <Zoom>
                    <img src={document} />
                  </Zoom>
                </div>
                  <h1 className="MobUploadedtx">uploaded file</h1>
                  <CloseIcon sx={{ color: red[600], fontSize: 25 }} />
              </div>
              <button className='submitButton GreenBack' type='submit'>Submit</button>
            </div>
            </Form>
            )}
          </Formik>
          </div>:null}
        </div>
      </div>
    </div>
    </>
  )
}

export default MobileAddServiceProvider